import { createSelector } from 'reselect';
import { getRequest } from './requestSelectors';
import { validationSchemaWithMarketConfig } from '../utils/validationSchemaUtils';
import { getIsSubmitted } from './formSelectors';
import { getMarketConfig } from './marketConfigSelector';

export const getValidationErrors = createSelector(
  getRequest,
  getMarketConfig,
  (request, marketConfig) => {
    try {
      validationSchemaWithMarketConfig(marketConfig).validateSync(request.toJS(), {
        abortEarly: false,
        marketConfig,
      });
      return null;
    } catch (validationErrors) {
      return validationErrors;
    }
  }
);

export const getErrorLabels = createSelector(
  getIsSubmitted,
  getValidationErrors,
  (isSubmitted, validationErrors) => {
    if (!validationErrors || !isSubmitted) {
      return [];
    }
    return validationErrors.errors;
  }
);

export const getHasErrors = createSelector(
  getErrorLabels,
  (intlErrors) => intlErrors.length > 0
);

export const getWarnings = createSelector(
  getErrorLabels,
  (errorLabels) => (
    errorLabels ? Object.values(errorLabels).filter((value) => value) : []
  )
);

export const getIsErrorByField = (fieldName) => createSelector(
  getIsSubmitted,
  getValidationErrors,
  (isSubmitted, validationErrors) => {
    const fieldErrors = [];
    if (validationErrors && isSubmitted) {
      validationErrors.inner.forEach(({ path, message }) => {
        if (path === fieldName) {
          fieldErrors.push(message);
        }
      });
    }
    return fieldErrors.length > 0;
  }
);

export const getErrorByField = (fieldName, formatMessage) => createSelector(
  getIsSubmitted,
  getValidationErrors,
  (isSubmitted, validationErrors) => {
    const fieldErrors = [];
    if (validationErrors && isSubmitted) {
      validationErrors.inner.forEach(({ path, message }) => {
        if (path === fieldName) {
          fieldErrors.push(message);
        }
      });
    }
    if (formatMessage && typeof formatMessage === 'function') {
      return fieldErrors.map((err) => {
        if (err.key) {
          return formatMessage({ id: `validation.${err.key}` }, { value: err.value });
        }
        return formatMessage({ id: `validation.${err}` });
      });
    }
    return fieldErrors;
  }
);

export const dateErrorSelector = (formatMessage) => createSelector(
  getErrorByField('startDate', formatMessage),
  getErrorByField('endDate', formatMessage),
  (startErrors, endErrors) => ({
    startDateErrors: startErrors.length > 0 ? startErrors : undefined,
    endDateErrors: endErrors.length > 0 ? endErrors : undefined,
  })
);
